module.exports = __webpack_public_path__ + "img/98.ce64525b.jpg";